import type { AuthUser } from "../../types/authUser";

/** The roles on the Team, as the Team screen shows them. */
export const TEAM_ROLES = ["Admin", "Owner", "Creator"] as const;
export type TeamRole = (typeof TEAM_ROLES)[number];

const ROLE_WORD = new RegExp(`\\b(${TEAM_ROLES.join("|")})s?\\b`, "i");

/** The role a message names, as the Team screen shows it: "the admins" is Admin. */
export function roleIn(text = ""): TeamRole | null {
  const found = text.match(ROLE_WORD)?.[1].toLowerCase();
  return TEAM_ROLES.find((role) => role.toLowerCase() === found) ?? null;
}

/** "Admin Members" on the Team screen counts Admins and Owners, not Creators. */
export function isAdminMember(accessLevel: string | undefined): boolean {
  const level = (accessLevel || "").trim().toLowerCase();
  return level === "admin" || level === "owner";
}

/** The roles someone can be given with ADD MEMBER. Admin can't be. */
export type AddableRole = "CREATOR" | "OWNER";

export const ADDABLE_ROLES: Array<{ value: AddableRole; label: TeamRole }> = [
  { value: "CREATOR", label: "Creator" },
  { value: "OWNER", label: "Owner" },
];

/** The roles this person may give someone they add: an Owner adds only Creators, a team Admin either. */
export function addableRoles(user: Pick<AuthUser, "userType" | "accessLevel"> | null | undefined) {
  if (user?.userType !== "team") return ADDABLE_ROLES;
  const level = (user?.accessLevel || "").trim().toLowerCase();
  if (level === "owner") return ADDABLE_ROLES.filter((l) => l.value === "CREATOR");
  if (level === "admin") return ADDABLE_ROLES;
  return [];
}
